import React from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EBookCard = ({ ebook, onAddToCart }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    if (ebook?.externalLink) {
      window.open(ebook?.externalLink, '_blank', 'noopener,noreferrer');
    } else {
      navigate(`/e-book-detail?id=${ebook?.id}`);
    }
  };

  const handleAddToCart = (e) => {
    e?.stopPropagation();
    onAddToCart(ebook);
  };

  const renderRatingStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;

    for (let i = 0; i < fullStars; i++) {
      stars?.push(
        <Icon key={`full-${i}`} name="Star" size={16} color="#fbbf24" className="fill-current" />
      );
    }

    if (hasHalfStar) {
      stars?.push(
        <Icon key="half" name="StarHalf" size={16} color="#fbbf24" className="fill-current" />
      );
    }

    const emptyStars = 5 - Math.ceil(rating);
    for (let i = 0; i < emptyStars; i++) {
      stars?.push(
        <Icon key={`empty-${i}`} name="Star" size={16} color="#475569" />
      );
    }

    return stars;
  };

  return (
    <div
      onClick={handleCardClick}
      className="rounded-xl shadow-md hover:shadow-2xl transition-all duration-300 cursor-pointer group overflow-hidden"
      style={{ backgroundColor: '#1e3a5f', border: '1px solid rgba(255,255,255,0.1)' }}
    >
      {/* Colored top accent bar */}
      <div
        className="h-1.5 w-full"
        style={{ background: 'linear-gradient(90deg, #0f172a 0%, #2563eb 50%, #fbbf24 100%)' }}
      />
      <div className="relative aspect-[3/4] overflow-hidden" style={{ backgroundColor: '#0f2d4a' }}>
        <Image
          src={ebook?.coverImage}
          alt={ebook?.coverImageAlt}
          className="w-full h-full object-cover group-hover:scale-105 transition-all duration-500"
        />
        {ebook?.isNew && (
          <div
            className="absolute top-3 right-3 px-3 py-1 rounded-md text-xs font-semibold font-caption"
            style={{ backgroundColor: '#fbbf24', color: '#0f172a' }}
          >
            NEW
          </div>
        )}
        {ebook?.isBestseller && (
          <div
            className="absolute top-3 left-3 px-3 py-1 rounded-md text-xs font-semibold font-caption"
            style={{ backgroundColor: '#0f172a', color: '#fbbf24', border: '1px solid #fbbf24' }}
          >
            BESTSELLER
          </div>
        )}
      </div>
      <div className="p-4 md:p-5 lg:p-6 space-y-3" style={{ backgroundColor: '#1e3a5f' }}>
        <div className="space-y-1">
          <h3
            className="text-base md:text-lg lg:text-xl font-heading font-semibold line-clamp-2 transition-colors duration-200"
            style={{ color: '#f1f5f9' }}
          >
            {ebook?.title}
          </h3>
          <p className="text-sm font-caption" style={{ color: '#94a3b8' }}>
            by {ebook?.author}
          </p>
        </div>

        <p className="text-sm line-clamp-3" style={{ color: '#cbd5e1' }}>
          {ebook?.description}
        </p>

        <div className="flex flex-wrap gap-2">
          {ebook?.frameworks?.slice(0, 2)?.map((framework, index) => (
            <span
              key={index}
              className="inline-flex items-center gap-1 px-2 py-1 rounded text-xs font-caption"
              style={{ backgroundColor: 'rgba(37,99,235,0.25)', color: '#93c5fd', border: '1px solid rgba(37,99,235,0.4)' }}
            >
              <Icon name="Target" size={12} />
              {framework}
            </span>
          ))}
          {ebook?.frameworks?.length > 2 && (
            <span
              className="inline-flex items-center px-2 py-1 rounded text-xs font-caption"
              style={{ backgroundColor: 'rgba(255,255,255,0.08)', color: '#94a3b8' }}
            >
              +{ebook?.frameworks?.length - 2} more
            </span>
          )}
        </div>

        <div
          className="flex items-center justify-between pt-3"
          style={{ borderTop: '1px solid rgba(255,255,255,0.1)' }}
        >
          <div className="space-y-0.5">
            <div
              className="text-2xl md:text-3xl font-heading font-bold"
              style={{ color: '#fbbf24' }}
            >
              ${ebook?.price?.toFixed(2)}
            </div>
            {ebook?.originalPrice && (
              <div className="text-sm line-through font-data" style={{ color: '#64748b' }}>
                ${ebook?.originalPrice?.toFixed(2)}
              </div>
            )}
          </div>

          <Button
            variant="default"
            size="default"
            iconName="ShoppingCart"
            iconPosition="left"
            onClick={ebook?.downloadUrl ? () => window.open(ebook?.downloadUrl, '_blank', 'noopener,noreferrer') : handleAddToCart}
            className="flex-shrink-0"
          >
            Download
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EBookCard;